module.exports = __webpack_public_path__ + "static/media/tenant.d3b39b35.png";